import script from "./EmployerDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployerDetails.vue?vue&type=script&setup=true&lang=js"

import "./EmployerDetails.vue?vue&type=style&index=0&id=62f835a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62f835a3"]])

export default __exports__